import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useSelector } from "react-redux";
const AnalyticsCards = () => {
  const translation = useSelector(state => state.root.translation);
  const cards = [
    {
      imgSrc: translation?.home_card_image1 || "https://pub-uploads.s3.amazonaws.com/uploads/chat/web/yV8xcPBCeB_Growing_statistic_transparent.png",
      title: translation?.complete_your_growthiq_setup || "Complete Your Growth IQ Setup",
      description:translation?.complete_your_growthiq_setup_content || "Easily configure your website or app to start tracking critical data. Finalize your account setup to unlock personalized insights and strategies tailored to your business needs. Ensure all necessary information is provided to maximize the benefits of our platform.",
      linkText: "Go to Setup Assistant",
      linkUrl: "#",
    },
    {
      imgSrc: translation?.home_card_image2  || "https://pub-uploads.s3.amazonaws.com/uploads/chat/web/TAApj1TCHP_Data_analysis_transparent.png",
      title: translation?.experience_growthiq_in_action || "Experience Growth IQ in Action",
      description:translation?.experience_growthiq_in_action_content || "Explore our platform's features. Analyze sample data, navigate through our tools, and discover how Growth IQ can drive your business growth. To analyze real-world data, track performance, and experiment with features that drive growth.",
      linkText: "Access the account",
      linkUrl: "#",
    },
    {
      imgSrc: translation?.home_card_image3 || "https://pub-uploads.s3.amazonaws.com/uploads/chat/web/OMmKGBmQoi_Analytics_data_transparent.png",
      title: translation?.enhance_your_analytics_skills || "Enhance Your Analytics Skills",
      description:translation?.enhance_your_analytics_skills_content || "Dive into our comprehensive resources to deepen your understanding of analytics. Learn how to interpret data effectively and apply insights to boost your business performance.",
      linkText: "Take the course on Skillshop",
      linkUrl: "#",
    },
  ];

  return (
    <div className="container my-4">
      <div className="row">
        {cards.map((card, index) => (
          <div className="col-md-4 mb-4" key={index}>
            <div className="card h-100 shadow-sm">
              <div className="card-body text-center home-card-body">
                <img
                  src={card.imgSrc}
                  alt={card.title}
                  className="mb-3"
                  style={{ height: "150px" }}
                />
                <h5 className="card-title">{card.title}</h5>
                <p className="card-text">{card.description}</p>
                {/* <a href={card.linkUrl} className="btn btn-link">
                  {card.linkText} <i className="bi bi-box-arrow-up-right"></i>
                </a> */}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnalyticsCards;
